/* unplugin-vue-components disabled */import script from "./GuideRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideRenderer.vue?vue&type=script&setup=true&lang=js"

import "./GuideRenderer.vue?vue&type=style&index=0&id=73df9bae&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73df9bae"]])

export default __exports__